// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/solana-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProgramName } from './ProgramName';
import {
    ProgramNameFromJSON,
    ProgramNameFromJSONTyped,
    ProgramNameToJSON,
} from './ProgramName';
import type { Source } from './Source';
import {
    SourceFromJSON,
    SourceFromJSONTyped,
    SourceToJSON,
} from './Source';

/**
 * 
 * @export
 * @interface ProgramInfo
 */
export interface ProgramInfo {
    /**
     * 
     * @type {Source}
     * @memberof ProgramInfo
     */
    source: Source;
    /**
     * 
     * @type {string}
     * @memberof ProgramInfo
     */
    account: string;
    /**
     * 
     * @type {ProgramName}
     * @memberof ProgramInfo
     */
    programName: ProgramName;
    /**
     * 
     * @type {string}
     * @memberof ProgramInfo
     */
    instructionName: string;
}

/**
 * Check if a given object implements the ProgramInfo interface.
 */
export function instanceOfProgramInfo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "account" in value;
    isInstance = isInstance && "programName" in value;
    isInstance = isInstance && "instructionName" in value;

    return isInstance;
}

export function ProgramInfoFromJSON(json: any): ProgramInfo {
    return ProgramInfoFromJSONTyped(json, false);
}

export function ProgramInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'source': SourceFromJSON(json['source']),
        'account': json['account'],
        'programName': ProgramNameFromJSON(json['programName']),
        'instructionName': json['instructionName'],
    };
}

export function ProgramInfoToJSON(value?: ProgramInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'source': SourceToJSON(value.source),
        'account': value.account,
        'programName': ProgramNameToJSON(value.programName),
        'instructionName': value.instructionName,
    };
}

